/// <amd-module name="typeahead/core/EmptyQueryRequestGenerator" />
/// <amd-dependency path="jquery" name="$"/>

import {RequestGenerator} from "typeahead/core/RequestGenerator";

function getQueryParams(options: any, context: IContext): IRequestParameters {
    return {
        categories: "USERHISTORY|FLIGHTSBOOKING",
        client: context.clientId,
        expuserid: context.expuserid,
        format: "jsonp",
        guid: context.guid,
        locale: context.locale,
        maxresults: options.maxresults,
        siteid: context.siteid,
    };
}

interface IRequestParameters {
    categories: string;
    client: string;
    expuserid: string;
    format: string;
    guid: string;
    locale: string;
    maxresults: number;
    siteid: string;
};

interface IResponsePromiseCache {
    requestParameters: IRequestParameters;
    responsePromise: JQueryPromise<any>;
}

export class EmptyQueryRequestGenerator extends RequestGenerator {

    private static responsePromiseCache: IResponsePromiseCache;

    constructor(essAbacusIds: string[], suggestServiceUrlOptions: ISuggestServiceUrlOptions) {
        super(essAbacusIds, undefined, suggestServiceUrlOptions, undefined, undefined);
    }

    public makeRequest(srchText: string, options: any, context: IContext): JQueryPromise<any> {
        let url = this.constructEssUrl(srchText);
        let requestParameters = getQueryParams(options, context);
        if (!EmptyQueryRequestGenerator.responsePromiseCache ||
            !_.isEqual(EmptyQueryRequestGenerator.responsePromiseCache.requestParameters, requestParameters)) {
            EmptyQueryRequestGenerator.responsePromiseCache = {
                requestParameters,
                responsePromise: $.ajax({
                    data: getQueryParams(options, context),
                    dataType: "jsonp",
                    timeout: 1000,
                    url,
                }),
            };
        }
        return EmptyQueryRequestGenerator.responsePromiseCache.responsePromise;
    }
}

/**
 * Function to allow the caller to provide the version of jQuery they want to use
 * and not rely on the page load time AMD module loader to provide one. This facilitates
 * unit testing so you can mock/stub/fake the jQuery functionality used in here.
 * @param jQuery
 */
export function overrideJQuery(jQuery: JQueryStatic): void {
    $ = jQuery;
}
